import React, { useState, useEffect } from "react";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";

// import JS files
import TableIconModal from "../../shares/TableIconModal";
import RingsSizeShow from "../../shares/RingsSizeShow";

const ShowRingSizes = (props) => {
  const [openModal, setOpenModal] = useState(false);

  return (
    <>
      <TableIconModal
        width="w-3/5"
        icon={<RemoveRedEyeIcon />}
        openModal={openModal}
        setOpenModal={setOpenModal}
      >
        <RingsSizeShow
          w1={props.selectedRow.size_one_weight}
          w2={props.selectedRow.size_two_weight}
          w3={props.selectedRow.size_three_weight}
          w4={props.selectedRow.size_four_weight}
          w5={props.selectedRow.size_five_weight}
          w6={props.selectedRow.size_six_weight}
          code={props.selectedRow.code}
          show_name={props.selectedRow.show_name}
          brand={props.selectedRow.brand_name}
          gender={props.selectedRow.gender}
          color={props.selectedRow.color}
        />
      </TableIconModal>
    </>
  );
};

export default ShowRingSizes;
